import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LoggedUserService } from "@keus-template/auth";

@Injectable({
  providedIn: "root",
})
export class AuthRedirectService {
  /** Injected the LoggedUserService */
  private readonly _loggedUserService: LoggedUserService =
    inject(LoggedUserService);

  /** Injected the Router */
  private readonly _router: Router = inject(Router);

  /**
   * Handles the initial redirect after login.
   * Now simplified - just redirect to home, the registration flow is handled automatically
   */
  public handleAuthRedirection(): void {
    const user = this._loggedUserService.currentUser();
    const currentUrl = this._router.url;

    // Only redirect from root path or when explicitly needed
    // All other routes should be preserved on refresh
    const needsRedirectRoutes = [
      "/",       // Root path
      "",        // Empty path
    ];
    
    // Routes that should never trigger a redirect
    const skipRedirectRoutes = [
      "/google-auth-callback",
      "/complete-registration",
    ];
    
    // Check if current URL should skip redirect
    const shouldSkipRedirect = skipRedirectRoutes.some(route => 
      currentUrl.startsWith(route)
    );
    
    if (shouldSkipRedirect) {
      return;
    }

    // Only redirect if we're at the root or an empty path
    // This preserves the current route on page refresh
    const isRootPath = needsRedirectRoutes.includes(currentUrl) || 
                       currentUrl === "/" || 
                       currentUrl === "";
    
    if (!isRootPath) {
      // We're on a specific route, don't redirect
      return;
    }

    // Only redirect from root to appropriate destination
    if (user) {
      // User has data, redirect to home
      this._router.navigate(["/home"]);
    } else {
      // No user data - for new users, redirect to complete-registration
      // This handles new registrations from Google
      this._router.navigate(["/complete-registration"]);
    }
  }
}
